<template>
  <div>
    <headerNotice routerName="添加活动"></headerNotice>
    <!-- 填写的数据 -->
    <div class="iptData">
      <!-- 数据填写 -->
      <el-form :model="formData" class="signUp_Form" label-width="150px">
        <el-row class="row">
          <el-col :span="8">
            <el-form-item label="活动名称:" :required="true">
              <el-input
                class="inputStyle"
                v-model="formData.name"
                placeholder="不能为空，1-20个字符"
                clearable
                size="medium"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="8">
            <el-form-item label="开始时间：" :required="true">
              <el-date-picker
                v-model="formData.startTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="8">
            <el-form-item label="结束时间：" :required="true">
              <el-date-picker
                v-model="formData.endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="8">
            <el-form-item
              :rules="{ required: true }"
              label="赠送限制次数:"
              label-width="138px"
            >
              <el-input
                placeholder="请输入数量"
                class="input-el"
                v-model="formData.limitCount"
                autocomplete="off"
                type="number"
              >
                <template slot="append">次</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="8">
            <el-form-item
              :rules="{ required: true }"
              label="领取限制次数:"
              label-width="138px"
            >
              <el-input
                placeholder="请输入数量"
                class="input-el"
                v-model="formData.limitGet"
                autocomplete="off"
                type="number"
              >
                <template slot="append">次</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="8">
            <el-form-item
              :rules="{ required: true }"
              label="赠品选择:"
              label-width="140px"
            >
              <el-select
                    v-model="formData.itemID"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in giveawayList"
                      :key="item.itemID"
                      :label="item.title"
                      :value="item.itemID"
                    ></el-option>
                  </el-select>

              <!-- <el-button
                style="margin-right: 35px"
                type="success"
                @click="openShowGiveaway()"
                >选择赠品</el-button
              >
              已选择
              {{ formData.title }} -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="sale" :span="10">
            <el-form-item label="卡片介绍:" label-width="140px">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入内容"
                v-model="formData.introduce"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="sale" :span="10">
            <el-form-item label="获取奖励:" label-width="140px">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入内容"
                v-model="formData.explain"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 表格商品操作 -->
      <div class="chooseAcitveGoods">
        <div class="title"><span>*</span> 选择活动卡片：</div>
        <el-tabs v-model="activeName" class="tabs">
          <el-tab-pane label="卡片选择" disabled name="first">
            <!-- 搜索栏 -->
            <div class="searchBox">
              <el-row :gutter="24">
                <el-col :span="5" :offset="0">
                  <el-select
                    v-model="formData.truckTemplateID"
                    placeholder="请选择"
                    @change="GetCard"
                  >
                  
                    <el-option
                      v-for="item in optionsList"
                      :key="item.name"
                      :label="item.name"
                      :value="item.truckTemplateID"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
            <el-table
              class="tableBox"
              :data="goodsList"
              style="width: 100%"
              :default-sort="{ prop: 'date', order: 'descending' }"
              ref="multipleTable"
              v-loading="loading"
            >
              <el-table-column
                align="center"
                prop="customer"
                label="商品图片"
                width="120"
              >
                <template slot-scope="scope">
                  <img
                    :src="imageurl + scope.row.image"
                    width="100"
                    height="100"
                    alt
                  />
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="商品名称"
              ></el-table-column>
              <el-table-column align="center" label="绑定产品" width="250">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.productID"
                    placeholder="请选择"
                    @change="joinDiscount(scope.row, scope.$index)"
                  >
                    <el-option
                      v-for="item in productList"
                      :key="item.id"
                      :label="item.productName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 表格赠品操作 -->
      <div class="add-box">
        <el-dialog width="1000px" title="选择赠品" :visible.sync="showGiveaway">
          <div class="chooseAcitveGoods">
            <div class="title"><span>*</span> 选择活动赠品：</div>
            <el-tabs v-model="activeName1" class="tabs">
              <el-tab-pane label="第一步：选择赠品" disabled name="first">
                <!-- 搜索栏 -->
                <div class="searchBox">
                  <el-row :gutter="24">
                    <!-- 搜索框 -->
                    <el-col :span="5" :offset="0">
                      <el-input
                        placeholder="请输入赠品名称/编号"
                        v-model="giveawayForm.word"
                      ></el-input>
                    </el-col>
                    <el-col :span="2" :offset="0">
                      <el-button type="primary" @click="searchGiveaway"
                        >查询</el-button
                      >
                    </el-col>
                  </el-row>
                </div>
                <el-table
                  class="tableBox"
                  :data="giveawayList"
                  style="width: 100%"
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  ref="multipleTablezp"
                  v-loading="loading"
                >
                  <el-table-column
                    align="center"
                    prop="customer"
                    label="赠品图片"
                    width="120"
                  >
                    <template slot-scope="scope">
                      <img
                        :src="baseUrl + scope.row.fileName"
                        width="100"
                        height="100"
                        alt
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="title"
                    label="赠品名称"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="stock"
                    label="库存数量"
                  ></el-table-column>
                  <el-table-column align="center" label="操作" width="250">
                    <template slot-scope="scope">
                      <el-button
                        v-if="!scope.row.checked"
                        @click="joinDiscount1(scope.row, scope.$index)"
                        type="primary"
                        size="small"
                        >添加赠品</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                  class="pagination"
                  @size-change="handleGoodsSizeChange1"
                  @current-change="handleGoodsCurrentChange1"
                  :page-sizes="[10, 20, 30, 40]"
                  layout="total, sizes, next"
                  :background="true"
                  next-text="点击加载更多⇣⇣"
                  :total="goodsTotalCount1"
                ></el-pagination>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-dialog>
      </div>
      <!-- 保存按钮 -->
      <div style="text-align: center">
        <el-button type="info" @click="cancel">返回</el-button>
        <el-button type="primary" :loading="btnLoading" @click="saveData"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import headerNotice from "../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      baseUrl: this.$store.state.apiUrl,
      imageurl: this.$store.state.URL,
      loading: false,
      formData: {
        introduce: "",
        explain: "",
        limitGet: 0,
        truckActivityID: 0,
        limitCount: 0,
        startTime: "",
        endTime: "",
        name: "",
        truckTemplateID: 0,
        gatherTogether: 0,
        itemID: 0,
        cardList: [
          {
            cardProductAssID: 0,
            cardID: 0,
            productID: 0,
          },
        ],
      },
      giftTotalCount: 0,
      giveawayList: [], // 赠品列表
      giveawayNum: 0, // 选中赠品数量
      showGiveaway: false, // 是否展示赠品列表弹出框
      chooseCustomerData: [], //所有选中的商品数据
      currentPageCustomer: [], //所有页选中的商品数据
      nowCurrentPageGift: [], //当前页选中的赠品数据
      currentPageGift: [], //所有页选中的赠品数据
      giveawayForm: {
        word: "",
      },
      activeName: "first",
      activeName1: "first",
      goodsTotalCount: 0, //商品总数据条数
      goodsTotalCount1: 0, //赠品总数据条数
      maxResultCount: 10, //默认一页显示的个数,
      optionsList: [], //所有模板
      goodsList: [],
      productList: [],
      productChooseList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      dialogLoading: false,
      btnLoading: false,
      singleJoinItem: [], //第一步 右边 单个 点击参加的 商品
      singleJoinItem1: [], //第一步 右边 单个 点击参加的 赠品
      choosedGoodsItem: [], //第一步 已经 勾选 的商品
      choosedGiftsItem: [], //第一步 已经 勾选 的赠品
      choosedJoinGoodsItem: [], //第一步 已经 勾选 要参加 的商品
      choosedJoinGiftsItem1: [], //第一步 已经 勾选 要参加 的赠品
      oneStepLastGoods: [], //第一步 去重  勾选等 处理完 最终的商品数组  即第二步的商品列表数组
      oneStepLastGoods1: [], //第一步 去重  勾选等 处理完 最终的赠品数组  即第二步的赠品列表数组
      canIChooseTab: true, //是否能点击第二步
      allDiscountType: 1, //1全部打折 2全部减价
      allDiscountVal: "", //全部打的折扣 或者减的价格
      secondChooseGoods: [], //第二步选择的商品
      secondChooseGoods1: [], //第二步选择的赠品
      clearToFixed: null, //抹去角和分 2   抹去角1
    };
  },
  components: {
    headerNotice,
  },
   created() {
        this.GetUserProduct();
      if (this.$route.query.Id) {
             this.getActive( this.$route.query.Id);
      }   
      
    },
  mounted() {
    this.getTemplate();
   
    this.getGiveaway({
      MaxResultCount: this.maxResultCount,
      ItemType: 3,
    });
  },
  methods: {
    ///模板列表
    getTemplate() {
      let self = this;
      self.loading = true;
      //获取分类
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/TruckTemplate/GetTruckTemplateList?SkipCount=0&MaxResultCount=1000",
        success(res) {
          self.optionsList = res.items;
          self.optionsList.push({
              truckTemplateID:0,
              name:"请选择"
          })
        },
        fail(res) {
          self.loading = false;
        },
      });
    },
     ///获取活动
    getActive(id) {
      let self = this;
      self.loading = true;
      var params={
  TruckActivityID: id,
      }
      //获取分类
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/TruckActivity/GetTruckActivity",
           params: params,
        success(res) {
          self.formData = res;
          self.goodsList = res.cardList;
          console.table(self.productChooseList);
           self.productChooseList= self.productChooseList.filter(item => ! self.goodsList.some(ele=>ele.productID === item.productID));

          //  self.productChooseList.forEach((ele, index) => {
          //      console.table(self.productChooseList);
          //   self.goodsList.forEach((ele2, index2) => {
          //      console.log("1:"+ele2.productID+",2:"+ele.productID);
          //     if (ele.productID == ele2.productID) {
          //       console.log("c:"+ele2.productID)
          //       self.productChooseList.findIndex(x=>x.productID=ele2.productID).splice(index, 1);             
          //     }
          //   });
           
         // });
          self.getproduct();
        },
        fail(res) {
          self.loading = false;
        },
      });
    },
    ///产品列表
    getproduct() {
      let self = this;
      self.loading = true;
      //获取分类
      $http.GET({
        url: "https://traceapi-t.ymkjc.com/api/ScanCode/GetProductListByCode?entCode=0174",
        success(res) {
          self.productList = res.data;
          
          self.productChooseList.forEach((ele, index) => {
            self.productList.forEach((ele2, index2) => {
              if (ele.productID == ele2.id) {
                self.productList.splice(index2, 1);
              }
            });
          });
        },
        fail(res) {
          self.loading = false;
        },
      });
    },
    GetCard() {
     this.getTemplateDetail(this.formData.truckTemplateID);
     this.getproduct();
    },

    ///获取已选择的产品
    GetUserProduct() {
      let self = this;
      self.loading = true;
      //获取分类
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/TruckActivity/GetUserProduct",
        success(res) {
          self.productChooseList = res;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        },
      });
    },
    ///模板卡片
    getTemplateDetail(truckTemplateID) {
      let self = this;
      self.loading = true;
      //获取分类
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/TruckTemplate/GetTruckTemplate?truckTemplateID=" +
          truckTemplateID,
        success(res) {
          self.goodsList = res.cardList;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        },
      });
    },
    //  查询赠品
    searchGiveaway() {
      let self = this;
      let Word = self.giveawayForm.word;
      if (status) {
        let params = {
          Word: Word,
          ItemType: 3,
          MaxResultCount: self.maxResultCount,
        };
        self.dialogLoading = true;
        $http.GET({
          url:
            this.$store.state.apiUrl +
            "/api/services/app/AdminIntegralExchange/GetAdminIntegralItem",
          params: params,
          success(res) {
            self.giveawayList = res.items;
            self.goodsTotalCount1 = res.totalCount;
            self.dialogLoading = false;
          },
          fail(res) {
            self.dialogLoading = false;
          },
        });
      } else {
        let params = {
          Word: Word,
          ItemType: 3,
          MaxResultCount: self.maxResultCount,
        };
        self.getGiveaway(params, true);
      }
    },
    //获取赠品列表数据
    getGiveaway(params, isSearch) {
      let self = this;
      self.dialogLoading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetAdminIntegralItem",
        params: params,
        success(res) {
          if (isSearch) {
            self.giveawayList = res.items;
          } else {
            self.giveawayList = self.giveawayList.concat(res.items);
          }
          self.giveawayList.forEach((ele1, index1) => {
            self.oneStepLastGoods1.forEach((ele2, index2) => {
              if (ele1.itemID == ele2.itemID) {
                self.giveawayList[index2].checked = true;
              }
            });
          });
          self.goodsTotalCount1 = res.totalCount;
          self.$forceUpdate();
          self.dialogLoading = false;
          self.loading = false;
        },
        fail(res) {
          self.dialogLoading = false;
          self.loading = false;
        },
      });
    },
    //打开赠品选择框
    openShowGiveaway() {
      let self = this;
      this.showGiveaway = true;
    },
    //产品选择
    joinDiscount(row, index) {
      let self = this;
      self.productChooseList.push(row.id);
      self.productList.forEach((ele2, index2) => {
        if (row.productID == ele2.id) {
          self.productList.splice(index2, 1);
        }
      });
    },
    //选择赠品
    joinDiscount1(row, index) {
      this.formData.itemID = row.itemID;
      this.formData.title = row.title;
      this.showGiveaway = false;
      console.log(1);
    },

    //第一步 一页显示多少个赠品
    handleGoodsSizeChange1(val) {
      this.maxResultCount = val;
      let params = {
        Word: this.giveawayForm.word,
        MaxResultCount: val,
        SkipCount: 0,
      };
      this.giveawayList = [];
      this.singleJoinItem1 = [];
      this.choosedJoinGoodsItem1 = [];
      this.oneStepLastGoods1 = [];
      this.secondChooseGoods1 = [];
      this.getGiveaway(params);
    },
    //第一步 跳转到指定页 商品
    handleGoodsCurrentChange1(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = this.giveawayForm;
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      this.getGiveaway(params, 0);
    },
    //返回
    cancel() {
      this.$router.back();
    },
    //保存数据
    saveData() {
      let self = this;
      self.btnLoading = true;
      let params = this.formData;
      params.cardList = this.goodsList;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/TruckActivity/AddTruckActivity",
        data: params,
        success(res) {
          self.$message({
            type: "success",
            message: "添加成功!",
          });
          let timer = setTimeout(() => {
            self.btnLoading = false;
            self.$router.push({
              path: "/activityList",
            });
            clearTimeout(timer);
          }, 1000);
        },
        fail(res) {
          self.btnLoading = false;
        },
      });
    },
  },
};
</script>

<style lang='scss' scoped>
//填写的数据
.iptData {
  padding: 20px 50px;
  .reduceBox {
    width: 30%;
    border: 1px solid #409eff;
    padding: 20px;
    padding-bottom: 0;
    margin-bottom: 20px;
    border-radius: 6px;
    .delBtn {
      display: block;
      margin: 0 auto;
      margin-bottom: 20px;
    }
  }
  .chooseAcitveGoods {
    .title {
      width: 140px;
      font-size: 14px;
      text-align: right;
      padding-right: 10px;
      color: #606266;
      span {
        color: #f63b3b;
      }
    }

    .tabs {
      padding: 20px 50px;
      .searchBox {
        padding-top: 20px;
      }
      .tableBox {
        margin-top: 20px;
        border: 1px solid #c5c5c5;
        /deep/ .handleTr .cell .el-row {
          display: flex;
          justify-content: space-between;
          input {
            padding: 0 5px;
            text-align: center;
          }
          .el-input-group__prepend {
            padding-left: 10px;
            padding-right: 10px;
          }
          .el-input-group__append {
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      }
      .fastHandle {
        padding: 20px 0;
        .row {
          display: flex;
          align-items: center;
        }
      }
      /deep/ .el-tabs__item.is-disabled {
        color: #333;
      }
      /deep/ .pagination {
        .btn-next {
          background: #eee;
          color: #333;
          padding: 0 10px;
          border-radius: 4px;
          border: 1px solid #c5c5c5;
        }
      }
    }
  }
}
</style>